import Signin from '../pages/access/Signin'
import AccessCallback from '../pages/access/AccessCallback'
import PolicyViewer from '../pages/policy/policy-details/PolicyViewer'
import AllTicketViewer from '../pages/policy/policy-details/AllTicketViewer'
import TicketViewer from '../pages/customer-debts/debts-details/TicketViewer'
import PolicyAttachmentViewer from '../pages/policy-registration/fragments/ViewerDocument/PolicyAttachmentViewer'
import MinutaViewer from '../pages/multi-calculation/quotations/judicial-guarantee-appeal/fragments/step-3/MinutaViewer'
import MulticalculoPolicyViewer from '../pages/multi-calculation-requests/view-request/fragments/PolicyViewer'
import MulticalculoBilletViewer from '../pages/multi-calculation-requests/view-request/fragments/BilletViewer'

const ExternalRoutes = [
  { path: '/callback', name: 'Callback', Component: AccessCallback },
  { path: '/signin', name: 'Acesso', Component: Signin },
  { path: '/boleto/:billingId', name: 'Boleto', Component: TicketViewer },
  { path: '/boleto-all/:documentNumber', name: 'Todos boletos', Component: AllTicketViewer },
  { path: '/apolices/:policyCode/documento', name: 'Documento', Component: PolicyViewer },
  { path: '/cadastro-de-apolices/:wingsDocumentId/documento', name: 'Documento', Component: PolicyAttachmentViewer },
  { path: '/multicalculo/visualizar-minuta/:proposalUniqueId/:insuranceUniqueId', name: 'Minuta', Component: MinutaViewer },
  { path: '/multicalculo/visualizar-apolice/:proposalUniqueId/:insuranceUniqueId/:policyUniqueId', name: 'Apólice', Component: MulticalculoPolicyViewer },
  { path: '/multicalculo/visualizar-boleto/:proposalUniqueId/:insuranceUniqueId/:policyUniqueId', name: 'Boleto', Component: MulticalculoBilletViewer },
]

export default ExternalRoutes
